import Styles from './UnsupportedRequestContent.module.scss'
import { UnsupportedRequestContentProps } from '../Types'
import { Button } from 'blaze-ui/Button'
import { generatePath, useHistory } from 'react-router-dom'
import { BRAND_KITS_PATH, DESIGN_PATH, BLAZE_POSTING_HELP_CENTER_URL, BLAZE_INTEGRATIONS_HELP_CENTER_URL } from 'paths'
import { ArrowUpRight } from 'blaze-ui/icons/16'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import useOpenWindowSafely from 'hooks/useOpenWindowSafely'
import { BlazeNewButton } from 'blaze-components/WorkspaceDashboardSidebar/components/NavMenu/Buttons/BlazeNewButton'
import { useModals } from 'almanac-ui/Modal'

const DesignNavigationButton = ({ design_id }: { design_id: string }) => {
  const history = useHistory()

  const handleOpenDesigner = () => {
    history.push(generatePath(DESIGN_PATH, { key: design_id }))
  }

  return (
    <div>
      <Button
        rounded
        variant="tertiary"
        size="sm"
        endIcon={() => <ArrowUpRight color="var(--dark-40)" />}
        onPress={handleOpenDesigner}
      >
        Edit in Designer
      </Button>
    </div>
  )
}

const BrandKitStylesNavigationButton = () => {
  const workspaceId = useCurrentWorkspaceId()
  const history = useHistory()

  const handleOpenBrandKitStyles = () => {
    history.push({ pathname: generatePath(BRAND_KITS_PATH, { workspaceId }), hash: 'styles_voice' })
  }

  return (
    <div>
      <Button
        rounded
        variant="tertiary"
        size="sm"
        endIcon={() => <ArrowUpRight color="var(--dark-40)" />}
        onPress={handleOpenBrandKitStyles}
      >
        Update Brand Styles
      </Button>
    </div>
  )
}

const BrandKitContentPreferencesNavigationButton = () => {
  const workspaceId = useCurrentWorkspaceId()
  const history = useHistory()

  const handleOpenBrandKitContentPreferences = () => {
    history.push({ pathname: generatePath(BRAND_KITS_PATH, { workspaceId }), hash: 'content_preferences' })
  }

  return (
    <div>
      <Button
        rounded
        variant="tertiary"
        size="sm"
        endIcon={() => <ArrowUpRight color="var(--dark-40)" />}
        onPress={handleOpenBrandKitContentPreferences}
      >
        Update Content Preferences
      </Button>
    </div>
  )
}

const HelpCenterNavigationButton = ({ url, label }: { url: string; label: string }) => {
  const openWindow = useOpenWindowSafely()

  const handleOpen = () => {
    openWindow(url)
  }

  return (
    <div>
      <Button
        rounded
        variant="tertiary"
        size="sm"
        endIcon={() => <ArrowUpRight color="var(--dark-40)" />}
        onPress={handleOpen}
      >
        {label}
      </Button>
    </div>
  )
}

const CreateNewNavigationButton = () => {
  const { closeAllModals } = useModals()

  return (
    <BlazeNewButton
      variant="primary"
      size="lg"
      label="Create New Content"
      endIcon={ArrowUpRight}
      frontIcon={undefined}
      withShimmer={false}
      openWizardsModal={false}
      onSuccess={() => closeAllModals()}
    />
  )
}

export const UnsupportedRequestContent = observer(({ content, isNextGen }: UnsupportedRequestContentProps) => {
  const { designStore } = useRootStore()
  const { navigation, design_id } = content
  const hasOnlyDesignNavigation = (navigation?.length ?? 0) > 0 && navigation?.every((n) => n === 'design')
  const isInDesign = designStore && design_id && designStore.fileId === design_id

  if (navigation == null || navigation?.length === 0 || (hasOnlyDesignNavigation && !design_id)) {
    return null
  }

  if (isNextGen && hasOnlyDesignNavigation) {
    return null
  }

  return (
    <div className={Styles.unsupportedRequestContent}>
      {!isNextGen && navigation.includes('design') && design_id && !isInDesign && (
        <DesignNavigationButton design_id={design_id} />
      )}
      {navigation.includes('brand_kit_styles') && <BrandKitStylesNavigationButton />}
      {navigation.includes('brand_kit_content_preferences') && <BrandKitContentPreferencesNavigationButton />}
      {navigation.includes('posting') && (
        <HelpCenterNavigationButton url={BLAZE_POSTING_HELP_CENTER_URL} label="Learn How to Schedule Posts" />
      )}
      {navigation.includes('integrations') && (
        <HelpCenterNavigationButton url={BLAZE_INTEGRATIONS_HELP_CENTER_URL} label="Set Up Integrations" />
      )}
      {navigation.includes('create_new') && <CreateNewNavigationButton />}
    </div>
  )
})
